import { Component } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '@group24ag/flowkit';

@Component({
  selector: 'app-not-found',
  imports: [CommonModule, NgOptimizedImage, RouterLink, ButtonComponent],
  template: `
    <section
      class="chrome--bg flex h-full flex-col items-center justify-center">
      <div class="flex flex-col">
        <div class="flex justify-center">
          <img
            class="size-full max-w-48 object-contain sm:max-w-52 xl:max-w-72"
            [ngSrc]="'./assets/images/state-404.svg'"
            width="126"
            height="150"
            alt="Error: 404 Page not Found"
            priority />
        </div>
        <h1
          class="heading-headline text--contrast-highest flex justify-center"
          i18n="@@common.not-found.header">
          Error: 404, We are sorry
        </h1>
        <p
          class="heading-subtitle flex justify-center"
          i18n="@@common.not-found.description">
          This page was not found.
        </p>
      </div>
      <a routerLink="/dashboard" flkButton i18n="@@common.not-found.button.back"
        >Back</a
      >
    </section>
  `,
})
export class NotFoundComponent {}
